import * as React from "react";
import { AudioPlayer } from "./AudioPlayer";
import { TestIds } from "../testIds";

export function Toolbar(): JSX.Element {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/90 text-slate-900 backdrop-blur dark:border-white/10 dark:bg-slate-900/80 dark:text-white md:h-[92px]"
      data-test="playback-toolbar"
      data-testid={TestIds.PlaybackToolbar}
    >
      <div className="flex h-full w-full items-center px-4 py-1 md:py-1.5 sm:px-5">
        <AudioPlayer />
      </div>
    </div>
  );
}
